import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';


function getEmbedUrl(url) {
  // YouTube
  let match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
  if (match) return `https://www.youtube.com/embed/${match[1]}?autoplay=1&rel=0`;

  // Vimeo
  match = url.match(/vimeo\.com\/(\d+)/);
  if (match) return `https://player.vimeo.com/video/${match[1]}?autoplay=1`;

  return url;
}


export default class Testimonials {
  constructor(quotesEl, personsEl) {
    this.quotesEl = quotesEl;
    this.personsEl = personsEl;
    this.section = quotesEl.closest('.testimonials');
    this.modal = this.section.querySelector('.testimonials--modal');
    this.modalVideo = this.modal.querySelector('.testimonials--modal-video');
    this.init();
    this.initModal();
  }

  init() {
    const swiper = new Swiper(this.quotesEl, {
      modules: [EffectFade, Autoplay],
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      slidesPerView: 1,
      allowTouchMove: true,
      autoplay: {
        delay: 25000,
        disableOnInteraction: false,
      },
    });

    // Délégation sur la section — fonctionne même si les boutons sont dans les slides
    this.section.addEventListener('click', (e) => {
      if (e.target.closest('.testimonials--prev')) swiper.slidePrev();
      if (e.target.closest('.testimonials--next')) swiper.slideNext();
    });

    if (this.personsEl) {
      new Swiper(this.personsEl, {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1.2,
        breakpoints: {
          768: { slidesPerView: 2.2, spaceBetween: 24 },
          992: { slidesPerView: 3, spaceBetween: 30 },
        },
      });
    }
  }

  initModal() {
    // Sortir le modal du flux pour éviter les problèmes de stacking context
    document.body.appendChild(this.modal);

    // Ouvrir — clic sur toute la card ou sur le bouton play
    this.section.querySelectorAll('.testimonials--card').forEach(card => {
      const btn = card.querySelector('.testimonials--card-play[data-video]');
      if (!btn) return;
      card.style.cursor = 'pointer';
      card.addEventListener('click', () => this.openModal(btn.dataset.video));
    });

    // Fermer — bouton close
    this.modal.querySelector('.testimonials--modal-close').addEventListener('click', () => this.closeModal());

    // Fermer — clic backdrop
    this.modal.querySelector('.testimonials--modal-backdrop').addEventListener('click', () => this.closeModal());

    // Fermer — Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeModal();
    });
  }

  openModal(videoUrl) {
    const embedUrl = getEmbedUrl(videoUrl);
    this.modalVideo.innerHTML = `<iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.setAttribute('aria-hidden', 'true');
    this.modalVideo.innerHTML = '';
    document.body.style.overflow = '';
  }
}
